module.exports = __webpack_public_path__ + "img/leeds-united-logo-icon.2fdfb125.png";